module.exports = __webpack_public_path__ + "img/attach.4a321347.svg";